import { render, staticRenderFns } from "./streamfieldBlock.vue?vue&type=template&id=4febc9c5&scoped=true&"
import script from "./streamfieldBlock.vue?vue&type=script&lang=js&"
export * from "./streamfieldBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4febc9c5",
  null
  
)

export default component.exports